import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { API_PARAMS } from '../../../config/consts'

interface GetStampUserCountDistributionRequest {
  serviceId: string
  campaignId?: string | null
  round?: string | null
  fromDate?: string | null // '2021-01-01'
  toDate?: string | null // '2021-01-02'
}

interface GetStampUserCountDistributionResponse {
  statusCode: number
  statusMessage: string
  currentPeriodValue: number
  previousPeriodValue: number
  userHoldingStampCountDatas: number[]
}

const useGetStampUserCountDistribution = ({
  serviceId,
  campaignId,
  round,
  fromDate,
  toDate,
}: GetStampUserCountDistributionRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetStampUserCountDistributionResponse> =>
    axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getStampUserCountDistribution`)
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  if (round && round !== '') url.searchParams.append('round', round)
  if (fromDate && fromDate !== '') url.searchParams.append('fromDate', fromDate)
  if (toDate && toDate !== '') url.searchParams.append('toDate', toDate)
  url.searchParams.append('campaignId', campaignId ?? API_PARAMS.SELECT_ALL)

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && campaignId && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )

  return {
    stampUserCountDistribution: data,
    stampUserCountDistributionLoading: isLoading,
    stampUserCountDistributionMutate: mutate,
  }
}

export default useGetStampUserCountDistribution
